/* =============================================
   CONPLANTAS HOME — JS
   Timer de franjas horarias, WA chat, ocasiones
   ============================================= */

(function () {
  'use strict';

  // ---- CONTADOR DE ENTREGA ----
  // La lógica y los textos vienen de los ajustes globales del tema, resueltos
  // por conplantas-countdown.js (window.cpCountdown).
  function updateTimer() {
    const box   = document.getElementById('cp-urgency-box');
    const icon  = document.getElementById('cp-urgency-icon');
    const label = document.getElementById('cp-urgency-label');
    const timer = document.getElementById('cp-timer');
    const desc  = document.querySelector('.cp-urgency-desc');
    if (!box || !timer || !window.cpCountdown) return;

    const state = window.cpCountdown.getState();

    if (!state.enabled) {
      box.style.display = 'none';
      return;
    }

    box.style.borderColor = state.closed ? 'var(--cp-borde)' : 'var(--cp-ambar)';
    if (icon) icon.textContent = state.closed ? '🌙' : '⏰';
    if (label) label.textContent = state.label;
    timer.style.color = state.closed ? 'var(--cp)' : 'var(--cp-urgencia)';
    timer.textContent = window.cpCountdown.formatDuration(state.remainingMs);

    if (desc) {
      // Los textos vienen de los ajustes del tema, ya escapados por el filtro
      // json del snippet; se reconstruye el bloque completo en cada tick.
      desc.textContent = state.desc;
      desc.appendChild(document.createElement('br'));
      const strong = document.createElement('strong');
      strong.id = 'cp-urgency-strong';
      strong.textContent = state.window;
      desc.appendChild(strong);
    }
  }

  // ---- ROTADOR DEL HERO ----
  function initHeroSlider() {
    const slider = document.querySelector('.cp-hero-slider');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('.cp-hero-slide'));
    if (slides.length < 2) return; // con una sola imagen no hay nada que rotar

    // Los puntos viven fuera del rotador (debajo de la imagen), así que se
    // buscan en la columna del hero, no dentro del slider.
    const scope = slider.closest('.cp-hero-right') || document;
    const dots = Array.from(scope.querySelectorAll('.cp-hero-dot'));
    const interval = parseInt(slider.dataset.interval, 10) || 5000;
    let current = 0;
    let timer = null;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');

        // Solo reproduce el video de la diapositiva visible: evita gastar datos
        // y batería con videos que nadie está viendo.
        const video = slide.querySelector('video');
        if (!video) return;
        if (active) {
          const playing = video.play();
          if (playing && playing.catch) playing.catch(() => {});
        } else {
          video.pause();
        }
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
    }

    function start() {
      stop();
      timer = setInterval(() => show(current + 1), interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(parseInt(dot.dataset.goto, 10));
        start(); // reinicia el conteo tras un clic manual
      });
    });

    // ---- ARRASTRE (touch y cursor) ----
    // Pointer Events cubre dedo, mouse y lápiz con el mismo código.
    slider.classList.add('is-draggable');
    const SWIPE_MIN = 45;   // px horizontales para que cuente como gesto
    const DRAG_SLOP = 8;    // px a partir de los cuales ya no es un clic
    let startX = 0;
    let startY = 0;
    let dragging = false;
    let moved = false;

    slider.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return; // solo botón izquierdo
      dragging = true;
      moved = false;
      startX = e.clientX;
      startY = e.clientY;
      stop();
    });

    slider.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      // Si el movimiento es más vertical que horizontal, es scroll de la página:
      // se abandona el gesto para no bloquearlo.
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > DRAG_SLOP) {
        dragging = false;
        start();
        return;
      }
      if (Math.abs(dx) > DRAG_SLOP) {
        moved = true;
        slider.classList.add('is-dragging');
      }
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      slider.classList.remove('is-dragging');
      const dx = e.clientX - startX;
      if (Math.abs(dx) >= SWIPE_MIN) {
        show(dx < 0 ? current + 1 : current - 1);
      }
      start();
    }

    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', () => {
      dragging = false;
      slider.classList.remove('is-dragging');
      start();
    });
    slider.addEventListener('pointerleave', endDrag);

    // Si el usuario arrastró, no debe abrirse el link de la diapositiva.
    slider.addEventListener('click', (e) => {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    // El navegador arrastra imágenes y enlaces por defecto; estorba al gesto.
    slider.addEventListener('dragstart', (e) => e.preventDefault());

    // Teclado: flechas izquierda/derecha cuando el rotador tiene el foco.
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { show(current - 1); start(); }
      else if (e.key === 'ArrowRight') { show(current + 1); start(); }
    });

    // No molestar mientras el usuario mira una imagen concreta.
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    // Pausa cuando la pestaña no está visible: evita saltos al volver.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else start();
    });

    // Todas las diapositivas traen autoplay para que la primera arranque sin
    // depender del JS; esto pausa las que no están visibles.
    show(0);

    // Respeta la preferencia del sistema de reducir movimiento.
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    reduced.addEventListener('change', (e) => (e.matches ? stop() : start()));
    if (reduced.matches) return;

    start();
  }

  // ---- OCCASION CARDS ----
  function initOccasionCards() {
    document.querySelectorAll('.cp-occasion-card').forEach(card => {
      card.addEventListener('click', () => {
        document.querySelectorAll('.cp-occasion-card').forEach(c => c.classList.remove('active'));
        card.classList.add('active');
      });
    });
  }

  // ---- WA PROACTIVE CHAT ----
  let waChatDismissed = false;
  let waChatOpen = false;

  function initWaChat() {
    const bubble = document.getElementById('cp-wa-chat-bubble');
    if (!bubble) return;

    // Aparece a los 30s sin interacción
    const timer = setTimeout(() => {
      if (!waChatDismissed) {
        bubble.classList.add('visible');
        waChatOpen = true;
      }
    }, 30000);

    // Si el usuario interactúa, no mostrar el chat proactivo
    const cancelProactive = () => clearTimeout(timer);
    document.addEventListener('click', cancelProactive, { once: true });
    document.addEventListener('scroll', cancelProactive, { once: true });

    // Float btn toggle
    const floatBtn = document.getElementById('cp-wa-float-btn');
    if (floatBtn) {
      floatBtn.addEventListener('click', () => {
        const msg = bubble.querySelector('.cp-wa-chat-message');
        if (!msg) return;
        if (waChatOpen) {
          msg.style.display = 'none';
          waChatOpen = false;
        } else {
          msg.style.display = 'block';
          bubble.classList.add('visible');
          waChatOpen = true;
        }
      });
    }

    // Close button
    const closeBtn = document.getElementById('cp-wa-chat-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        const msg = bubble.querySelector('.cp-wa-chat-message');
        if (msg) msg.style.display = 'none';
        waChatDismissed = true;
        waChatOpen = false;
      });
    }
  }

  // ---- INIT ----
  function init() {
    updateTimer();
    setInterval(updateTimer, 1000);
    initHeroSlider();
    initOccasionCards();
    initWaChat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
